import { Injectable, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Item } from '../../model/item';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { StateService } from "../../services/state/state.service";
import { RestService } from '../../services/rest/rest.service';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { TimeChrono } from "../../model/timeChrono";
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { CONFIG } from '../../constants/constants';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { ToolkitService } from '../../services/toolKit/toolkit.service';
import { DateServerService } from '../../services/dateServerService/date-server.service';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { ExamEvaluationConfService } from '../../services/examEvaluationConf/examEvaluationConf.service';


declare var $: any;

@Component({
  selector: 'footer-visualizer',
  templateUrl: './footer-visualizer.component.html',
  styleUrls: ['./footer-visualizer.component.css']
})


//Controlador para el footer del visualizador de items
@Injectable()
export class FooterVisualizerComponent implements OnInit {


  //Indica el numero de horas restantes en el cronometro
  public hours: number;

  //indica el num ero de minutos restantes en el cronometro
  public minutes: number;

  //indica el num ero de segundos restantes en el cronometro
  public seconds: number;

  //Corresponde a la información del item actual para la barra de progreso
  public item: Item;

  //Representa el indice de progreso actual
  public progresoActual: number;

  //Indica el total de progreso a llegar
  public progresoTotal: number;

  //Representa el porcentaje de avance de la prueba
  public porcentajeAvance: number;

  public totalTime: number;

  public sesion: number;

  public showChrono: Boolean;
  public intervalSuperPro: any;



  //Constructor de la clase
  constructor(
    private _welcomeService: WelcomeService,
    private _stateService: StateService,
    private _restService: RestService,
    private _tokenController: TokenControlService,
    private _configurationService: ConfigurationService,
    public _configurationControlService: ConfigurationControlService,
    public _answerController: AnswerControlService,
    public _toolkitService: ToolkitService,
    public _dateServerService: DateServerService,
    public examEvaluationConfService: ExamEvaluationConfService
  ) {

    this._configurationControlService.showToolKit = false;
    this.totalTime = 0;
    if (this._stateService != null && this._stateService.state != null) {
      this.sesion = this._stateService.state.sesion;
    } else if (this._tokenController.token.sesion != null) {
      this.sesion = this._tokenController.token.sesion;
    } else {
      this.sesion = 0;
    }

    this.progresoActual = 0;
    this.progresoTotal = 0;
    //this.porcentajeAvance = 0;
  }

  //Necesario debido a la implementacion de la interfaz AfterViewInit
  //Se ejecuta una vez se ha inicializado la vista
  public ngOnInit() {
    // ✅ Validar que los servicios necesarios estén inicializados
    if (!this._tokenController.token || !this._configurationControlService.examConfiguration) {
      console.warn('Token o configuración no disponibles en footer-visualizer');
      return;
    }

    this._configurationService.inhabilitarBotonAtras();
    let self = this;
    this.showChrono = false;

    self._configurationControlService.online = true;
    self.intervalSuperPro = setInterval(() => {
      this.callRequest();
    }, 10000);
    if (self._configurationControlService.examConfiguration.chrono && self._configurationControlService.startChrono) {
      this.getTimeChrono();
    }

    //this.actualizarInfoProgreso();
  }

  public callRequest() {
    let self = this;
    let online = CONFIG.ONLINE;
    if (online) {
      self._configurationService.callRequest().then(res => {
        self._configurationControlService.online = true;
        self._dateServerService.setDateServer(res.dateService);
        // ✅ Verificar que token existe antes de acceder a userType
        if (this._tokenController.token && this._tokenController.token.userType == 5) {
          self.examEvaluationConfService.disabledButtons(false);
        }
      }).catch(err => {
        self._configurationControlService.online = false;

        // ✅ Verificar que token existe antes de acceder a userType
        if (this._tokenController.token && this._tokenController.token.userType == 5) {
          self.examEvaluationConfService.disabledButtons(true);
        }
      })
    } else {
      self._configurationControlService.online = false;
    }
    if (self._configurationControlService.sessionInfo.estado == ESTADO_SESSION_INFO.FINALIZA_PRUEBA || this._configurationControlService.stopIntervalFlag) {
      clearInterval(self.intervalSuperPro);
    }
  }

  /**Metodo encargado de ir al servicio para capturar el tiempo restante */
  public getTimeChrono() {
    let online = CONFIG.ONLINE;
    if (online) {
      this._restService.getTestChrono(this._tokenController.token.token,
        this._tokenController.token.credentialId,
        this._tokenController.token.tokenId).then(
          res => {
            this.startChrono(res);
          }
        )
    } else {
      this.startChrono(new TimeChrono(null, null, null, null));
      setTimeout(() => {
        let timeChrono = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
        timeChrono ? timeChrono.timeChrono ? this.agregarChronoPoint(timeChrono) : null : null
      }, 1000);
    }
  }

  agregarChronoPoint(timeChrono): void {
    let self = this;
    self._configurationControlService.chronoStartAndEnd = [...self._configurationControlService.chronoStartAndEnd, timeChrono];
  }


  public startChrono(timeChrono: TimeChrono) {
    let session = this._welcomeService.data.sessions[this.sesion - 1];
    if (this._stateService.deadLine == null) {
      this._stateService.deadLine = new Date();

      this.totalTime = 0;
      for (let j = 0; j < session.subjects.length; j++) {
        let subject = session.subjects[j];
        this.totalTime += subject.subjectDuration;
      }

      let totalHours = this._stateService.previousTime ? +this._stateService.previousTime.hours : Math.round(this.totalTime / 60);
      let totalMinutes = this._stateService.previousTime ? +this._stateService.previousTime.minutes : Math.round((this.totalTime / 60 - totalHours) * 60);
      let totalSeconds = this._stateService.previousTime ? +this._stateService.previousTime.seconds : 0;

      if (timeChrono.timeChrono != null && timeChrono.sesion == this._stateService.state.sesion) {
        timeChrono.timeChrono = JSON.parse(timeChrono.timeChrono);
        this._stateService.timeChrono = JSON.parse(JSON.stringify({
          "hours": parseInt(timeChrono.timeChrono.hours, 10),
          "minutes": parseInt(timeChrono.timeChrono.minutes, 10),
          "seconds": parseInt(timeChrono.timeChrono.seconds, 10),
        }));
      } else {
        this._stateService.timeChrono = JSON.parse(JSON.stringify({
          "hours": totalHours,
          "minutes": totalMinutes,
          "seconds": totalSeconds
        }));
      }

      this._stateService.deadLine.setHours(this._stateService.deadLine.getHours() + this._stateService.timeChrono.hours);
      this._stateService.deadLine.setMinutes(this._stateService.deadLine.getMinutes() + this._stateService.timeChrono.minutes);
      this._stateService.deadLine.setSeconds(this._stateService.deadLine.getSeconds() + this._stateService.timeChrono.seconds);
    }
    let self = this;
    let timeinterval = setInterval(async () => {
      self.showChrono = true;
      let t = self._stateService.getTimeRemaining(self._stateService.deadLine);
      self._stateService.timeChrono.seconds = ('0' + ((t.seconds * -1))).slice(-2);
      self._stateService.timeChrono.minutes = ('0' + ((t.minutes * -1) - 1)).slice(-2);
      self._stateService.timeChrono.hours = ('0' + ((t.hours * -1) - 1)).slice(-2);
      if (self._stateService.timeChrono.hours == 0 && self._stateService.timeChrono.minutes < 5) {
        $("#testChrono span").css("color", "red");
      }
      if (t.total >= 0) {
        $("#btnEndTestHidden").click();
        self._stateService.endTime = true;
        self._stateService.timeChrono.hours = "00";
        self._stateService.timeChrono.minutes = "00";
        self._stateService.timeChrono.seconds = "00";
        try {
          let timeChronoEnd = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
          if (!(timeChrono.timeChrono.hours == "00" && timeChrono.timeChrono.minutes == "00" && timeChrono.timeChrono.seconds == "00")) {
            await self._restService.saveTestChrono(self._tokenController.token.token, timeChronoEnd, self._tokenController.token.tokenId);
          }
        } catch (error) {
          console.error(error)
        }
        clearInterval(timeinterval);
      }
    }, 1000);
  }

  //Se encarga de actualziar la informacion de
  //la barra de progreso
  /*public actualizarInfoProgreso(sesion: number){
    let self = this;
      this.progresoTotal = self._itemService.progressBar.total;
      self._answerService.getExamProgress(sesion).then((result: any) => {
        let progress = result;
        self.progresoActual = result;
         self.porcentajeAvance = (self.progresoActual / self.progresoTotal) * 100;
        $("#progressBar").attr("aria-valuenow", progress);
        $("#progressBar").attr("aria-valuemax", self.progresoTotal);
        $("#progressBar").attr("style", "width: " +  Math.round(self.porcentajeAvance) + "%");
        $("#valorPorcentaje").remove();
        $("#porcentaje").append( "<p id='valorPorcentaje'>Avance del " + Math.round(self.porcentajeAvance) + "%</p>" );
      });

  }*/

}
